import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@heroui/react";
import { EError } from "@sc07-canvas/lib";
import { useEffect, useState } from "react";

import { useAppContext } from "../../contexts/AppContext";
import { handleError, oapi } from "../../lib/utils";
import { Button } from "../core/Button";
import { type IUser, UserCard } from "./UserCard";

export const ProfileModal = () => {
  const { profile, setProfile } = useAppContext();
  const [user, setUser] = useState<IUser>();

  useEffect(() => {
    if (!profile) {
      setUser(undefined);
      return;
    }

    oapi
      .GET("/user/{sub}", {
        params: {
          path: {
            sub: profile,
          },
        },
      })
      .then(({ data, error, response }) => {
        if (data) {
          setUser(data.user);
        }
        if (error) {
          handleError(new EError(error, response.status));
        }
      });
  }, [profile]);

  return (
    <Modal isOpen={!!profile} onClose={() => setProfile()} placement="center">
      <ModalContent className="canvas-overlay-card">
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">Profile</ModalHeader>
            <ModalBody>
              {user ? (
                <UserCard user={user} hide={["VIEW_PROFILE"]} />
              ) : (
                <>Loading...</>
              )}
            </ModalBody>
            <ModalFooter>
              <Button onPress={onClose}>Close</Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
